import { useEffect, useRef } from 'react';

import { css } from '@emotion/css';
import { ScreenBreakpoint } from 'src/styles';

import { drawDonutChart } from './drawDonutChart';

const modalButtonStyle = css`
  min-width: 280px;
  min-height: 280px;

  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    min-width: 100%;
  }
`;

interface DonutChartProps {
  total: number;
  data: number[];
  colors: string[];
}

export const DonutChart = ({ total, data, colors }: DonutChartProps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) drawDonutChart(total, ref.current, data, colors);
  }, [ref, total, data, colors]);

  return (
    <div className={modalButtonStyle}>
      <div className='graph' ref={ref} />
    </div>
  );
};
